import { createHistory } from 'history';
import { useRouterHistory } from 'react-router';
import useEmbeddedPathname from './useEmbeddedPathname';

export default useRouterHistory(useEmbeddedPathname(createHistory))();



// WEBPACK FOOTER //
// ./js/util/browserHistory.js